import type { SectionPodcastSummary } from '@/lib/api-client';
import { isPodcastInFlight } from '@/hooks/lesson/useSectionPodcasts';

/** Where a section's podcast is, as its controls show it. */
export type PodcastPhase =
  | 'making'
  | 'ready'
  | 'failed'
  | 'locked'
  | 'not_made';

/** `busy`: a request for it is in flight on this page. */
export function podcastPhase(
  summary: SectionPodcastSummary,
  busy = false
): PodcastPhase {
  if (summary.status === 'completed') return 'ready';
  if (busy || isPodcastInFlight(summary.status)) return 'making';
  if (summary.status === 'failed') return 'failed';
  return summary.locked ? 'locked' : 'not_made';
}
